export const RESPONSE_STATUS = {
  SUCCESS : 'success',
  ERROR   : 'error'
};
